import { render, staticRenderFns } from "./AfssPreferences.vue?vue&type=template&id=340a2bed&scoped=true&"
import script from "./AfssPreferences.vue?vue&type=script&lang=js&"
export * from "./AfssPreferences.vue?vue&type=script&lang=js&"
import style1 from "./AfssPreferences.vue?vue&type=style&index=1&id=340a2bed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340a2bed",
  null
  
)

export default component.exports